<template>
	<v-container>
    <v-card class="mt-12">
      <v-card-text>
        <v-row>
          <v-col> 
            <v-text-field type="password" v-model="usuario.senha" label="Nova Senha" required dense></v-text-field>
          </v-col>
          <v-col> 
            <v-text-field type="password" v-model="usuario.confirmSenha" label="Confirmar Nova Senha" required dense></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary" class="mr-1" @click="save">salvar</v-btn>
            <v-btn color="grey" class="ml-1" dark @click="reset">cancelar</v-btn>     
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { baseApiUrl, showError } from '@/global'
  export default {

    name: 'NewPassword',

    data () {
      return {
        usuario:{}
     }
   },
   methods:{
    save() {
      axios.post(`${baseApiUrl}/resetPassword/${this.token = this.$route.params.token}`, this.usuario)
      .then(() => {
        this.$toasted.global.defaultSuccess()
        setTimeout(() =>{
          this.$router.push({name:"auth"}).catch(() => {})
        }, 2000)
      })
      .catch(showError)
    },
    reset() {
      this.usuario = {}
    }
  }

}
</script>

<style lang="css" scoped>
</style>